import jApplicationSetting from '@/views/setting/jApplicationSetting';
import jApplicationDetail from '@/views/setting/jApplicationDetail';
import jPagesSetting from '@/views/pages/jPagesSetting';
import jWidgetSetting from '@/views/widget/jWidgetSetting';
import jBoardSetting from '@/views/board/jBoardSetting';

import auth from '@/middleware/auth';
import log from '@/middleware/log';
import admin from '@/middleware/admin';

export default [
  {
    path: '/setting/application',
    name: 'jApplicationSetting',
    component: jApplicationSetting,
    meta: {
      title: 'Application Setting',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  {
    path: '/setting/application/:applicationId',
    name: 'jApplicationDetail',
    component: jApplicationDetail,
    meta: {
      title: 'Edit Application',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  {
    path: '/setting/application/:type/:groupId',
    name: 'jApplicationDetail',
    component: jApplicationDetail,
    meta: {
      title: 'Edit Application',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  {
    path: '/setting/application/:applicationId/:applicationName/page/:pageId',
    name: 'jPagesSetting',
    component: jPagesSetting,
    meta: {
      title: 'Edit Application',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  {
    path: '/widget',
    name: 'jWidgetSetting',
    component: jWidgetSetting,
    meta: {
      title: 'Widget Setting',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  {
    path: '/setting/board',
    name: 'jBoardSetting',
    component: jBoardSetting,
    meta: {
      title: 'Board Setting',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/jRouterSetting.js